import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { UpdateEventDocument } from './update.generated';

export const useUpdateEvent = (options: ApiOptions<typeof UpdateEventDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(UpdateEventDocument, {
    ...useNotifications(UpdateEventDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.events.update_success'),
    }),
    ...options,
  });
};
